import React, { useState } from 'react';
import { FilePdf as FilePdfIcon, CircleNotch as SpinnerIcon } from '@phosphor-icons/react';
const BACKGROUND = '#01332b';
export function DownloadPdfButton() {
  const [status, setStatus] = useState<'idle' | 'working' | 'error'>('idle');
  async function handleDownload() {
    setStatus('working');
    try {
      const [{
        default: html2canvas
      }, {
        jsPDF
      }] = await Promise.all([import('html2canvas'), import('jspdf')]);
      const slides = Array.from(document.querySelectorAll<HTMLElement>('main > section'));
      if (slides.length === 0) throw new Error('No slides found');
      let pdf: import('jspdf').jsPDF | null = null;
      for (const slide of slides) {
        const canvas = await html2canvas(slide, {
          backgroundColor: BACKGROUND,
          scale: Math.min(2, window.devicePixelRatio || 1.5),
          useCORS: true,
          imageTimeout: 15000,
          logging: false,
          windowWidth: 1440
        });
        const width = canvas.width;
        const height = canvas.height;
        const image = canvas.toDataURL('image/jpeg', 0.92);
        if (!pdf) {
          pdf = new jsPDF({
            orientation: width >= height ? 'landscape' : 'portrait',
            unit: 'px',
            format: [width, height],
            compress: true
          });
        } else {
          pdf.addPage([width, height], width >= height ? 'landscape' : 'portrait');
        }
        pdf.addImage(image, 'JPEG', 0, 0, width, height);
      }
      pdf?.save('Solventum-Filtek-Clinical-Case-Teasers.pdf');
      setStatus('idle');
    } catch (error) {
      console.error(error);
      setStatus('error');
      window.setTimeout(() => setStatus('idle'), 4000);
    }
  }
  const label = status === 'working' ? 'Preparing PDF…' : status === 'error' ? 'Try again' : 'Download PDF';
  return <button type="button" onClick={handleDownload} disabled={status === 'working'} aria-live="polite" className="no-print fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 rounded-full border border-white/20 bg-background/85 px-4 py-2.5 font-body text-[11px] font-medium uppercase tracking-[0.16em] text-white/70 backdrop-blur transition-colors hover:border-primary/60 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-wait disabled:opacity-70" data-id="element-25" data-mp="3aki3g98ow9rs">
      {status === 'working' ? <SpinnerIcon size={15} className="animate-spin" aria-hidden="true" data-id="element-26" data-mp="2jn0ujaq28akg" /> : <FilePdfIcon size={15} aria-hidden="true" data-id="element-27" data-mp="2fl5usans258s" />}
      {label}
    </button>;
}